// "Update available": the app knows its own build id and asks the server for the current
// one whenever it comes to the foreground (and every ten minutes while open). A crew
// member sees a banner and taps Refresh; nobody has to close, swipe away or reinstall.
import { useEffect, useState } from 'react';

const EVERY = 10 * 60_000;

async function currentBuild(): Promise<string | null> {
  try {
    const r = await fetch('/build.json', { cache: 'no-store' });
    if (!r.ok) return null;
    return ((await r.json()) as { build?: string }).build ?? null;
  } catch { return null; }
}

export function useUpdateAvailable(): boolean {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    let stopped = false;
    const check = async () => { const b = await currentBuild(); if (!stopped && b && b !== __BUILD_ID__) setStale(true); };
    const onVisible = () => { if (document.visibilityState === 'visible') void check(); };
    void check();
    const t = setInterval(check, EVERY);
    document.addEventListener('visibilitychange', onVisible);
    return () => { stopped = true; clearInterval(t); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return stale;
}

export function applyUpdate() {
  // Drop the shell cache so the next load is the new index.html, then reload.
  const go = () => location.reload();
  if ('caches' in window) caches.keys().then(ks => Promise.all(ks.filter(k => k.startsWith('tv-shell-')).map(k => caches.delete(k)))).then(go, go);
  else go();
}
